import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import CallCenterLogo from '../../assets/logo/call-center.png'
import {
  Phone,
  Map,
  Mail,
  Report,
  ChevronUp,
  ChevronDown,
  ChevronLeftLarge,
  ExternalLink,
} from '../icons'
import { useState } from 'react'

const Container = styled.div`
  max-height: 600px;
  height: auto;
  z-index: 2;
  background: #5e514d;
  color: white;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
  border-radius: 0px 12px;
  text-align: start;
  padding: 16px;
  bottom: 1em !important;
  right: 1em !important;
  position: fixed !important;

  @media screen and (max-width: 767px) {
    right: 1em !important;
    bottom: 1em !important;
  }
`

const Label = styled.div`
  color: rgba(255, 255, 255, 0.35);
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  margin-top: 24px;
  margin-bottom: 0;
`

const Header = styled.div`
  &:hover {
    cursor: pointer;
  }
`
const Content = styled.div`
  padding-top: 19px;
  max-height: 600px;
  height: auto;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .content-item {
    cursor: pointer;
    text-decoration: none;
    color: #fff;
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .border-bottom-custom-0 {
    border-bottom: none;
  }
`

const ChatBox = function () {
  const [status, setStatus] = useState(false)
  const { t } = useTranslation()

  return (
    <Container>
      <div>
        <Header
          className="d-flex bd-highlight align-items-center w-100"
          onClick={() => setStatus(!status)}
        >
          <div className="d-flex text-start w-100 bd-highlight">
            <img
              src={CallCenterLogo}
              width="24px"
              height="24px"
              className="me-2"
              alt=""
            />
            {t('contact_us')}
          </div>
          <div className="flex-shrink-1 bd-highlight ps-3">
            {status ? <ChevronUp fill="#fff" /> : <ChevronDown fill="#fff" />}
          </div>
        </Header>
        {status ? (
          <Content>
            <div className="content-item d-flex bd-highlight align-items-center w-100">
              <div className="d-flex text-start w-100 bd-highlight">
                <Phone
                  fill="#fff"
                  width="24px"
                  height="24px"
                  className="me-2"
                />{' '}
                14005
              </div>
              <div className="flex-shrink-1 bd-highlight"></div>
            </div>

            <a
              href="/network/kantor"
              className="content-item d-flex bd-highlight align-items-center w-100 pb-3"
            >
              <div className="d-flex text-start w-100 bd-highlight">
                <Map fill="#fff" width="24px" height="24px" className="me-2" />
                Kantor Cabang
              </div>
              <div className="content-item flex-shrink-1 bd-highlight"></div>
            </a>
            <a
              href="mailto:customer_care@kbbukopin.com"
              className="content-item d-flex bd-highlight align-items-center w-100 pb-3"
              target="_blank"
              rel="noreferrer"
            >
              <div className="d-flex text-start w-100 bd-highlight">
                <Mail fill="#fff" width="24px" height="24px" className="me-2" />
                {t('send_email')}
              </div>
              <div className="flex-shrink-1 bd-highlight">
                <ChevronLeftLarge fill="#fff" />
              </div>
            </a>
            <a
              href="/corporate-governance/whistleblowing-system"
              className="content-item border-bottom-custom-0 d-flex bd-highlight align-items-center w-100 pb-3"
            >
              <div className="d-flex text-start w-100 bd-highlight">
                <Report
                  fill="#fff"
                  width="24px"
                  height="24px"
                  className="me-2"
                />
                <div
                  className="me-2"
                  dangerouslySetInnerHTML={{ __html: t('report') }}
                ></div>
              </div>
              <div className="flex-shrink-1 bd-highlight">
                <ExternalLink fill="#fff" />
              </div>
            </a>

            {/*
            <Label>{t('teller_service')}</Label>

             <a
              href="https://etf.bukopin.co.id/E-Form_Public/web_eform/tarik_tunai"
              className="content-item d-flex bd-highlight align-items-center w-100 pb-3"
              target="_blank"
              rel="noreferrer"
            >
              <div className="d-flex text-start w-100 bd-highlight">
                {t('withdraw_cash')}
              </div>
              <div className="flex-shrink-1 bd-highlight">
                <ChevronLeftLarge fill="#fff" />
              </div>
            </a>

            <a
              href="https://etf.bukopin.co.id/E-Form_Public/web_eform/setor_tunai"
              className="content-item d-flex bd-highlight align-items-center w-100 pb-3"
              target="_blank"
              rel="noreferrer"
            >
              <div className="d-flex text-start w-100 bd-highlight">
                {t('deposit_cash')}
              </div>
              <div className="flex-shrink-1 bd-highlight">
                <ChevronLeftLarge fill="#fff" />
              </div>
            </a>

            <a
              href="https://etf.bukopin.co.id/E-Form_Public/web_eform/pindah_buku  "
              className="content-item border-bottom-custom-0 d-flex bd-highlight align-items-center w-100 pb-3"
              target="_blank"
              rel="noreferrer"
            >
              <div className="d-flex text-start w-100 bd-highlight">
                {t('book_transfer')}
              </div>
              <div className="flex-shrink-1 bd-highlight">
                <ChevronLeftLarge fill="#fff" />
              </div>
            </a> */}

            <Label>{t('customer_service')}</Label>

            <a
              href="https://etf.bukopin.co.id/E-Form_Public/web_eform/buka_tabungan"
              className="content-item d-flex bd-highlight align-items-center w-100 pb-3"
              target="_blank"
              rel="noreferrer"
            >
              <div className="d-flex text-start w-100 bd-highlight">
                {t('open_account')}
              </div>
              <div className="flex-shrink-1 bd-highlight">
                <ChevronLeftLarge fill="#fff" />
              </div>
            </a>
          </Content>
        ) : null}
      </div>
    </Container>
  )
}

export default ChatBox
